import { render, staticRenderFns } from "./ModalDuplicateProject.vue?vue&type=template&id=52432936&scoped=true&"
import script from "./ModalDuplicateProject.vue?vue&type=script&lang=js&"
export * from "./ModalDuplicateProject.vue?vue&type=script&lang=js&"
import style0 from "./ModalDuplicateProject.vue?vue&type=style&index=0&id=52432936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52432936",
  null
  
)

export default component.exports